import * as React from 'react';

import { IDocument, IUserDownloadList, IEditorState, IUserData } from '../../../infrastructure/interfaces';
import formatDate from '../../utils/formatDate';
import { getScrollbarWidth } from '../../../lib/helpers';
import { Route } from 'react-router-dom';
import { TooltipCont } from '../../../infrastructure/tooltips';
export interface IDocumentTableProps {
  documents: any[];
  editor: IEditorState;
  documentInProgress: IDocument | null;
  userData: IUserData;
  userDownloadList: IUserDownloadList[];
  onEditDocument(id: number): void;
  onDeleteDocument(id: number): void;
  onDownload(document: IDocument): void;
  onOpenOrdersPreview(document: IDocument): void;
  onOpenCloneProject(document: IDocument): void;
}

export default class DocumentsTable extends React.Component<IDocumentTableProps>{
  tableRow: HTMLElement;
  render() {
    const {
      documentInProgress,
      documents,
      editor,
      onDeleteDocument,
      onEditDocument,
      onOpenOrdersPreview,
      onOpenCloneProject,
      onDownload,
      userData,
    } = this.props;

    const isAdmin = (userData.role != "user");

    const containerCSSClass = isAdmin
      ? "inner-home-su-container"
      : "inner-home-container";

    return (
      <div className={containerCSSClass}>
        <div className="manage-items-row-offsetRight">
          <div className="in-row-text-container">
            My Product Sales Collateral
          </div>
          <div className="in-row-button-container">
            {(isAdmin && documentInProgress && editor.selectedPage) &&
              <Route
                render={({ history }) => {
                  return (
                    <button className="btn primary-blue large" onClick={() => history.push('/Editor')} title={TooltipCont.TO_EDITING}>
                      Go Back to Editing
                    </button>
                  );
                }}
              />}
            {(isAdmin) &&
              <Route
                render={({ history }) => {
                  return (
                    <button
                      className="btn primary-green large"
                      onClick={() => history.push('/LandingPage')}
                      title={TooltipCont.CREATE_DOCUMENT}
                    >
                      Create New Project
                    </button>);
                }}
            />}
          </div>
        </div>
        <table className="table-scrollable documents-table">
          <thead style={{ paddingRight: getScrollbarWidth() }}>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Date of last modification</th>
              <th>Action</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody className="document-table-body">
            {documents.map((d, index, array) =>
              <tr key={d.id} ref={tr => this.tableRow = tr!}>
                <td>{d.document.name}</td>
                <td>{d.document.type == "Brochure" ? "Quad Fold" : d.document.type}</td>
                <td>{formatDate(d.last_modified)}</td>
                <td>
                  <div className="button-wrapper">
                    <button
                      className="btn primary-blue"
                      onClick={() => onEditDocument(d.id)}
                      title={TooltipCont.EDIT}
                      disabled={this.props.userDownloadList.some(el => el.id === d.id)}
                    >
                      Edit
                    </button>

                    <button
                      className="btn primary-blue"
                      onClick={() => onOpenOrdersPreview(d.document)}
                      title={TooltipCont.ORDER_PRINTS}
                      disabled={false}
                    >
                      Order Prints
                    </button>
                  </div>

                  <div className="button-wrapper">
                    <button
                      className="btn primary-blue"
                      onClick={() => onOpenCloneProject(d.document)}
                      title={TooltipCont.CLONE_DOCUMENT}
                      disabled={false}
                    >
                      Clone
                    </button>

                    <button
                      className="btn primary-red"
                      onClick={() => onDeleteDocument(d.id)}
                      title={TooltipCont.DELETE}
                      disabled={false}
                    >
                      Delete
                    </button>
                    
                  </div>
                </td>
                <td>
                  <button
                    className="btn download"
                    onClick={() => onDownload(d.document)}
                    title={TooltipCont.CONVERT_TO_PDF}
                    disabled={this.props.userDownloadList.some(el => el.id === d.id)}
                  >
                    <img className="download-logo" src={require('../img/downloadsNew.svg')} />
                    <span>PDF</span>
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/Home/components/DocumentsTable.tsx